// extracted by mini-css-extract-plugin
export var lg = "_2t-4";
export var md = "_2t-3";
export var sm = "_2t-2";
export var xs = "_2t-1";
export var xxs = "_2t-0";